import { createFileRoute } from "@tanstack/react-router"

import { VoxSenseRoutingView } from "@/features/voxsense/components/voxsense-routing-view"

export const Route = createFileRoute("/_shell/voxsense/routing/")({
  component: VoxSenseRoutingView,
})
